import { useThemeConfig } from '../../hooks/useThemeConfig'
import { WidgetProps } from '../../widget.types'
import { WidgetTheme } from '../../WidgetTheme'
import * as Styles from './styles'

export const InterviewStrategy = ({ service }: WidgetProps) => {
  const themeState = useThemeConfig({ service })
  const theme = themeState.initial

  return (
    <WidgetTheme theme={theme} tipOrder={2}>
      <Styles.Container>Interview strategy</Styles.Container>
    </WidgetTheme>
  )
}
